import React from "react";
import "./About.css";
import Headerabout from "../../components/Headerabout";
import HeaderImage from "../../images/header_bg_1.jpg";
import Header_storty from "../../images/about1.jpg";
import Image2 from '../../images/about2.jpg'
import Image3 from '../../images/about3.jpg'



function About() {
  return (
    <>
      <Headerabout title="About Us" image={HeaderImage} />

      <section className="aboutstory">
       
      <div className="container story__contain">
          <div className="about_story_image">
            <img src={Header_storty} alt="" />
          </div>
          <div className="about_Section-conten">
            <h1>Our Story</h1>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Odio,
              voluptas totam vero eum accusantium quae fugiat distinctio saepe
              mollitia corrupti possimus a rem tenetur et. Similique delectus
              
             
            </p>
            <p>
            voluptas totam vero eum accusantium quae fugiat distinctio saepe
            mollitia corrupti possimus a rem tenetur et. Similique delectus
            doloremque eveniet sunt?
            </p>

            <p>
            doloremque eveniet suntLorem ipsum dolor, 
            sit amet consectetur adipisicing elit. Odio,
            </p>

          </div>
        </div>

      </section>
      <section className="about__Vision">
        <div className="container Vision__contain">
          
          <div className="about_Section-conten">
            <h1>Our Vision</h1>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Odio,
              voluptas totam vero eum accusantium quae fugiat distinctio saepe
              mollitia corrupti possimus a rem tenetur et. Similique delectus
              
             
            </p>
            <p>
            voluptas totam vero eum accusantium quae fugiat distinctio saepe
            mollitia corrupti possimus a rem tenetur et. Similique delectus
            doloremque eveniet sunt?
            </p>

            <p>
            doloremque eveniet suntLorem ipsum dolor, 
            sit amet consectetur adipisicing elit. Odio,
            </p>

          </div>
          <div className="about_story_image1">
            <img src={Image2} alt="" />
          </div>
        </div>
      </section>
      <section className="aboutmision">
        <div className="container mision__contain">
          <div className="about_story_image">
            <img src={Image3} alt="" />
          </div>
          <div className="about_Section-conten">
            <h1>Our Story</h1>
            <p>
              Lorem ipsum dolor, sit amet consectetur adipisicing elit. Odio,
              voluptas totam vero eum accusantium quae fugiat distinctio saepe
              mollitia corrupti possimus a rem tenetur et. Similique delectus
              
             
            </p>
            <p>
            voluptas totam vero eum accusantium quae fugiat distinctio saepe
            mollitia corrupti possimus a rem tenetur et. Similique delectus
            doloremque eveniet sunt?
            </p>

            <p>
            doloremque eveniet suntLorem ipsum dolor, 
            sit amet consectetur adipisicing elit. Odio,
            </p>

          </div>
        </div>
      </section>
    </>
  );
}

export default About;
